export enum ModifiableCodeEnum {
    System = 'System',
    Client = 'Client',
}
